import { ReactElement } from 'react';
import {
  Badge,
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTrigger,
  MenuItem,
  useDialogController,
} from '@ff-it/ui';
import { Form, Submit, useSubmitHandler } from '@ff-it/form';
import { AttachmentField } from 'modules/attachments/AttachmentField';
import useSWR, { KeyedMutator } from 'swr';
import type { Attachment } from 'modules/attachments/types';

interface AttachmentFormProps {
  url: string;
  initialValues: any;
  mutate: KeyedMutator<any>;
}

function AttachmentForm({ url, initialValues, mutate }: AttachmentFormProps): ReactElement {
  const { setOpen } = useDialogController();
  const onSubmit = useSubmitHandler(
    { url, method: 'POST' },
    {
      onSuccess: (data) => {
        mutate(data, { revalidate: false });
        setOpen(false);
      },
    },
  );

  return (
    <Form onSubmit={onSubmit} initialValues={initialValues}>
      <DialogBody>
        <AttachmentField name="plan_attachments" discriminator="plan" />
      </DialogBody>
      <DialogFooter>
        <DialogClose />
        <Submit ml="auto" />
      </DialogFooter>
    </Form>
  );
}

interface PlanAttachmentsProps {
  endpoint: string;
}

export function AttachmentButton({ endpoint }: PlanAttachmentsProps): ReactElement {
  const url = `${endpoint}plan_attachments/`;
  const { data, mutate } = useSWR<{ plan_attachments: Attachment[] }>({ url, method: 'GET' });

  return (
    <Dialog>
      <DialogTrigger>
        <MenuItem
          label="Attachments"
          suffix={data?.plan_attachments.length ? <Badge count={data.plan_attachments.length} /> : undefined}
        />
      </DialogTrigger>
      <DialogContent>
        <DialogHeader title="Plan attachments" />
        {data && <AttachmentForm initialValues={data} url={url} mutate={mutate} />}
      </DialogContent>
    </Dialog>
  );
}
